import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { EditLayout } from "../../../TaxCorrections/components/EditLayout";
import { OverlaySpinner } from "../../../../components/OverlaySpinner";
import { analyticsService } from "@services/analyticsService";
import { useMutationCreateBulkCalculate1099Batch } from "../../../BulkImporter/query/bulkCalculation1099/mutations";
import { OLD_TAX_CURRENT_YEAR } from "../../constants/currentYear";

export const RouteInitGenerate1099NECAmounts: React.FC = () => {
  const history = useHistory<{
    canSkip?: boolean;
  }>();
  const [createBulk1099CalculateBatch] =
    useMutationCreateBulkCalculate1099Batch();

  useEffect(() => {
    createBulk1099CalculateBatch(
      {
        labels: {
          filingYear: `${OLD_TAX_CURRENT_YEAR}`
        }
      },
      {
        onSuccess: bulkBatch => {
          analyticsService.track("1099 Filing Bulk 1099 Calculation Started");
          history.replace({
            pathname: `/member/1099-filing/generate-1099-nec-amounts/${bulkBatch.bulkCalculation1099BatchId}`,
            state: history.location.state || {}
          });
        }
      }
    );
  }, []);

  return (
    <EditLayout title="Generate amounts and statuses">
      <OverlaySpinner />
    </EditLayout>
  );
};
